export enum TrackingCase {
    UserTracking = 'User Tracking',
    PageNavigation = 'Page Navigation',
  };